import * as React from 'react';
import { ODataParams, Query } from '../../Components/Query';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { DataCorrectionQueryTable } from './DataCorrectionQueryTable';
import { useWebPortalApiClient } from '../../misc/api/WebPortalTokenClient';

export const DataCorrectionListScreen = ({ cachedQuery, setCachedQuery }) => {
    const client = useWebPortalApiClient();
    const { study } = useCurrentStudyConfigurationContext();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `studyId eq ${study.id}`;

        return await client.client.getDcfRequests(undefined, filter, params.orderby, 'site($select=id,number,country),subject($select=id,number),visit($select=id,name),session($select=id,name,occurred)', params.top, params.skip);
    }

    return (
        <Query onRefresh={handleRefresh} initialOrdering={[{ field: "label", condition: "asc" }]} onQueryCompleted={(p) => setCachedQuery(p)} savedQuery={cachedQuery}>
            <DataCorrectionQueryTable />
        </Query>
    );
};
